import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AppUserType } from '@/types/user';

export type UserState = {
  dataAppUser: AppUserType[];
};

export const userInitialState: UserState = {
  dataAppUser: [],
};

export const slice = createSlice({
  name: 'user',
  initialState: userInitialState,
  reducers: {
    setAppUserAction(state, { payload }: PayloadAction<{ dataAppUser: AppUserType[] }>) {
      state.dataAppUser = payload.dataAppUser;
    },
  },
});

export const { setAppUserAction } = slice.actions;

export default slice.reducer;
